export default ({to, form, router, next}) => {
    const user = JSON.parse(localStorage.getItem('auth')) || null
    if (user) {
        return router.push({ name: 'formation-index' });
    }
    return next();
}

